import GalleriesService from '../services/galleries';
import ForumUtils from './forum';

export class PaginatedGalleryList extends ForumUtils.PaginatedList {

    constructor(params, options) {
        const fetchFn = async (limit, offset) => {
            const resParams = Object.assign({}, params, { limit, offset });
            if (options && options.cache) {
                resParams.cache = options.cache
            }
            const res = await GalleriesService.getGalleries(resParams);
            return {
                items: res.galleries,
                count: res.totalGalleries,
            };
        };
        super(fetchFn, options);
    }

    get galleries() {
        return this.items;
    }

    /* See ForumUtils.PaginatedList for details.

    isLoading() {}

    hasMore() {}

    loadMore() {}

    find() {}

    */
}

export default {
    PaginatedGalleryList,
};



// WEBPACK FOOTER //
// ./src/utils/galleries.js